/* eslint-disable @typescript-eslint/camelcase */
export enum Locale {
  en = 'en',
  da_DK = 'da_DK',
  de_AT = 'de_AT',
  de_CH = 'de_CH',
  de_DE = 'de_DE',
  de_LU = 'de_LU',
  en_AU = 'en_AU',
  en_CA = 'en_CA',
  en_GB = 'en_GB',
  en_IE = 'en_IE',
  es_ES = 'es_ES',
  es_MX = 'es_MX',
  fi_FI = 'fi_FI',
  fr_BE = 'fr_BE',
  fr_CA = 'fr_CA',
  fr_CH = 'fr_CH',
  fr_FR = 'fr_FR',
  fr_LU = 'fr_LU',
  it_CH = 'it_CH',
  it_IT = 'it_IT',
  ja_JP = 'ja_JP',
  ko_KR = 'ko_KR',
  nb_NO = 'nb_NO',
  nl_BE = 'nl_BE',
  nl_NL = 'nl_NL',
  nn_NO = 'nn_NO',
  pl_PL = 'pl_PL',
  pt_BR = 'pt_BR',
  ru_RU = 'ru_RU',
  sv_SE = 'sv_SE',
  tr_TR = 'tr_TR',
  es_BO = 'es_BO',
  es_CL = 'es_CL',
  en_KY = 'en_KY',
  es_CR = 'es_CR',
  nl_CW = 'nl_CW',
  en_CW = 'en_CW',
  es_DO = 'es_DO',
  es_EC = 'es_EC',
  es_SV = 'es_SV',
  fr_GF = 'fr_GF',
  fr_GP = 'fr_GP',
  es_GT = 'es_GT',
  en_JM = 'en_JM',
  fr_MQ = 'fr_MQ',
  es_PA = 'es_PA',
  es_PY = 'es_PY',
  es_PE = 'es_PE',
  nl_SX = 'nl_SX',
  en_SX = 'en_SX',
  en_LC = 'en_LC',
  en_TT = 'en_TT',
  es_UY = 'es_UY',
  bg_BG = 'bg_BG',
  es_CO = 'es_CO',
  en_CY = 'en_CY',
  en_EE = 'en_EE',
  hr_HR = 'hr_HR',
  hu_HU = 'hu_HU',
  en_IN = 'en_IN',
  lt_LT = 'lt_LT',
  ru_LT = 'ru_LT',
  lv_LV = 'lv_LV',
  ru_LV = 'ru_LV',
  en_NZ = 'en_NZ',
  ro_RO = 'ro_RO',
  sv_SK = 'sv_SK',
  th_TH = 'th_TH',
  en_TH = 'en_TH',
  it_VA = 'it_VA',
  es_VE = 'es_VE',
  vi_VN = 'vi_VN'
}

export const brandContext = process.env.VUE_APP_BRAND || 'Audi';
